var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.storeOfferSets)?_c('div',[(_vm.hasManufacturerRights)?_c('calcofferitemmanufacturer'):_c('calcofferitemcustomer',{on:{"offer-selection-changed":_vm.offerSelectionChanged}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }